import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";

import useStyles from '../../../pages/HomePage.style';
import ProfilePage from '../../../pages/ProfilePage';
import ClaimsPage from '../../../pages/ClaimsPage';
import { ClaimsOverviewPage } from '../../../pages/Claims/ClaimsOverviewPage';

import { Provider as SupportProvider } from '../../../contexts/support/supportContext';
import { useLanguageContext } from '../../../contexts/langContext';
import { TmAdminPage } from '../../../pages/TmAdminPage';
import PaymentPage from '../../../pages/PaymentPage';
import SupportPage from '../../../pages/SupportPage';
import { LogoutPage } from '../../../pages/LogoutPage';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { TmAdminMemberInfoPage } from '../../../pages/Admin/TmAdminMemberInfoPage';
import { CarrierReport } from '../../../pages/Admin/CarrierReport';
import ManualIngestPage from '../../../pages/ManualIngestPage';
import VOBPage from '../../../pages/VOBPage';
import SteerageOverviewPage from '../../../pages/SteeragePage/SteerageOverviewPage';
import SteerageDetailsPage from '../../../pages/SteeragePage/SteerageDetailsPage';
import { useAuthContext } from '../../../contexts/authContext';
import { ReleaseFormsPage } from 'pages/ReleaseFormsPage';
import { MedicalRecordsPage } from 'pages/MedicalRecordsPage';
import { UB04IngestPage } from 'pages/ManualIngestPage/UB04IngestPage';
import { CMS1500IngestPage } from 'pages/ManualIngestPage/CMS1500IngestPage';
import { AutomationPage } from 'pages/AutomationPage';
import { featureFlagService } from '../../../services/featureFlags';
import { BillsPage } from '../../../pages/BillsPage';
import { PaymentsPage } from '../../../pages/Finance/PaymentsPage';
import { ProcessPaymentsPage } from '../../../pages/Finance/ProcessPaymentsPage';
import { EligibilityOverviewPage } from '../../../pages/Eligibility/EligibilityOverviewPage';
import { TasksPage } from '../../../pages/TasksPage';
import { FairFareAI } from '../../../pages/FairFareAI';
import WhatsAppDemoPage from '../../../pages/Demo/WhatsAppDemoPage';
import { canEditClaims, canReadClaims } from '../../../utils/roles';

export default function DashboardContent() {
  const classes = useStyles();
  const { dir } = useLanguageContext();
  const { user } = useAuthContext();
  const { role } = user || { role: '' };
  const hasReadRole = canReadClaims(role);
  const isAdmin = canEditClaims(role);
  const isSuperUser = role === 'super_user';
  const isSupportAgent = role === 'customer_support_agent';
  // Workers keep the pages they have today (tasks); everyone else needs a claims role.
  const hasClaimsAccess = hasReadRole || isSupportAgent || role === 'worker';

  // Check feature flags
  const featureFlagContext = {
    tenantId: localStorage.getItem('tenantId') || undefined,
    userId: user?.id?.toString(),
    userRole: user?.role,
  };
  const isAutomationEnabled = featureFlagService.isEnabled(
    'automation',
    featureFlagContext
  );

  return (
    <main className={classes.content}>
      {/* <div className={classes.appBarSpacer} /> */}
      <Container
        maxWidth="xl"
        className={classes.container}
        style={{ direction: dir }}
      >
        <Grid container spacing={3} style={{ width: '100%' }}>
          <ErrorBoundary>
            <Switch>
              <Route path="/ai-chat">
                <Helmet>
                  <title>FairFare AI</title>
                </Helmet>
                <Grid item xs={12}>
                  <FairFareAI />
                </Grid>
              </Route>
              {isAdmin && (
                <Route path="/billing">
                  <Helmet>
                    <title>FairFare Billing</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <PaymentPage />
                  </Grid>
                </Route>
              )}
              {isAdmin && (
                <Route path="/profile">
                  <Helmet>
                    <title>Profile</title>
                  </Helmet>
                  <Grid container className={classes.gridContainer}>
                    <ProfilePage />{' '}
                    {/* TODO: work on the profile page for carriers */}
                  </Grid>
                </Route>
              )}
              {/* <Route path="/support/new" exact>
                <Helmet>
                  <title>FairFare New Support Ticket</title>
                </Helmet>
                <Grid item xs={12}>
                  <SupportProvider>
                    <SupportPageNewTicket />
                  </SupportProvider>
                </Grid>
              </Route> */}
              {/* <Route path="/support/history" exact>
                <Helmet>
                  <title>FairFare Support Tickets</title>
                </Helmet>
                <Grid item xs={12}>
                  <SupportProvider>
                    <SupportPageUserHistory />
                  </SupportProvider>
                </Grid>
              </Route> */}
              {/* <Route path="/support/:ticketId">
                <Helmet>
                  <title>FairFare Support</title>
                </Helmet>
                <Grid item xs={12}>
                  <SupportProvider>
                    <SupportPageConversation />
                  </SupportProvider>
                </Grid>
              </Route> */}
              {isAdmin && (
                <Route path="/support">
                  <Helmet>
                    <title>FairFare Support</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <SupportProvider>
                      <SupportPage />
                    </SupportProvider>
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/admin">
                  <Helmet>
                    <title>FF Admin Page</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <TmAdminPage />
                  </Grid>
                </Route>
              )}
              {isAdmin && (
                <Route path="/automation">
                  <Helmet>
                    <title>FairFare Automation</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <AutomationPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/member-info">
                  <Helmet>
                    <title>FF Admin member info</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <TmAdminMemberInfoPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/carrier-report">
                  <Helmet>
                    <title>FF Admin reports</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <CarrierReport />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/manual-ingest" exact>
                  <Redirect to="/manual-ingest/cms1500" />
                </Route>
              )}
              {isSuperUser && (
                <Route path="/manual-ingest/cms1500">
                  <Helmet>
                    <title>FF Admin Manual Ingestion - CMS1500</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <CMS1500IngestPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/manual-ingest/ub04">
                  <Helmet>
                    <title>FF Admin Manual Ingestion - UB04</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <UB04IngestPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/medical-records">
                  <Helmet>
                    <title>Medical Records Update</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <MedicalRecordsPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/release-forms" exact>
                  <Helmet>
                    <title>RRF</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <ReleaseFormsPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/steerage" exact>
                  <Redirect to="/steerage/overview" />
                </Route>
              )}
              {hasReadRole && (
                <Route path="/steerage/overview">
                  <Helmet>
                    <title>FairFare Steerage Overview</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <SteerageOverviewPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/steerage/details">
                  <Helmet>
                    <title>FairFare Steerage Details</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <SteerageDetailsPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/claims" exact>
                  <Redirect to="/claims/overview" />
                </Route>
              )}
              {hasReadRole && (
                <Route path="/claims/overview">
                  <Helmet>
                    <title>Claims Overview</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <ClaimsOverviewPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/claims/cases">
                  <Helmet>
                    <title>Claims Cases</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <ClaimsPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/claims/bills">
                  <Helmet>
                    <title>Claims Bills</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <BillsPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/finance" exact>
                  <Redirect to="/finance/payments" />
                </Route>
              )}
              {hasReadRole && (
                <Route path="/finance/payments">
                  <Helmet>
                    <title>Finance - Payments</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <PaymentsPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/finance/process-payments">
                  <Helmet>
                    <title>Process Payments</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <ProcessPaymentsPage />
                  </Grid>
                </Route>
              )}
              {isSuperUser && (
                <Route path="/demo/whatsapp">
                  <Helmet>
                    <title>Demo - WhatsApp</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <WhatsAppDemoPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/eligibility" exact>
                  <Helmet>
                    <title>FairFare Eligibility</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <EligibilityOverviewPage />
                  </Grid>
                </Route>
              )}
              {hasReadRole && (
                <Route path="/tasks">
                  <Helmet>
                    <title>Tasks</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <TasksPage />
                  </Grid>
                </Route>
              )}
              {(isSupportAgent || isSuperUser) && (
                <Route path="/vob">
                  <Helmet>
                    <title>FairFare VOB</title>
                  </Helmet>
                  <Grid item xs={12}>
                    <VOBPage />
                  </Grid>
                </Route>
              )}
              <Route path="/logout">
                <Helmet>
                  <title>FF Logout</title>
                </Helmet>
                <Grid item xs={12}>
                  <LogoutPage />
                </Grid>
              </Route>
              <Route path="/">
                <Helmet>
                  <title>{isSupportAgent ? 'VOB' : 'Claims'}</title>
                </Helmet>
                {/* AnalysisPage */}
                <Grid container className={classes.gridContainer}>
                  {isSupportAgent ? (
                    <VOBPage />
                  ) : hasClaimsAccess ? (
                    <Redirect to="/claims" />
                  ) : (
                    // Signed in, but with a role that works elsewhere (an agent works in
                    // steerage) or none yet: say so rather than show an empty dashboard.
                    <Grid item xs={12} style={{ padding: 32 }}>
                      <h2 style={{ marginBottom: 8 }}>You don&apos;t have access to the claims dashboard</h2>
                      <p>
                        Your account is set up for another FairFare app, or hasn&apos;t been given access yet. Ask your
                        administrator if you need it.
                      </p>
                    </Grid>
                  )}
                </Grid>
              </Route>
            </Switch>
          </ErrorBoundary>
        </Grid>
      </Container>
    </main>
  );
}
